@switch (selectedLayout()) {
  @case ('blank') {
    <app-blank-layout />
  }

  @default {
    <app-default-layout />
  }
}
